import React, {useState, useEffect, useRef} from 'react'
import { Box, Stack, Tabs, Tab, Typography, Button } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { styled, useTheme } from '@mui/system';
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useReactToPrint } from 'react-to-print';
import { apiURL } from './App';
import { ThemeInputText, SecondButton } from './Controls';
import { authFetch, authJson } from './apiClient';
import MemoEditMap from './MemoEditMap';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';

// 初期表示中心位置
const defaultCenter = {
  lat: parseFloat(process.env.REACT_APP_INIT_LAT || '36.000'),
  lng: parseFloat(process.env.REACT_APP_INIT_LON || '138.000')
};

// ロケールを日本語に設定
dayjs.locale('ja');

// コンテナ
const Container = styled('div')({
//  display: 'flex',
//  flexDirection: 'column',
//  justifyContent: 'flex-start',
//  alignItems: 'flex-start',
  //padding: '30px',
//  backgroundColor: '#fff',
//  position: 'relative',
//  top: '0',
//  bottom: '0',
  width: '100%',
  height: '100%'
});

// タブパネル
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="panel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

// スタイル
const styles = {
  grid: {
    // 列ヘッダに背景色を指定
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: '#fff5e5', 
    }
  }
}

// タブのアクセシビリティ属性設定
function tabProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

// メモ編集ダイアログ
const EditMemoDialog = (props) => {
    const [memo, setMemo] = useState({});
    const [open, setOpen] = useState(false); // 確認ダイアログの表示/非表示
    const { control, register, handleSubmit, setValue, getValues, reset } = useForm();

    useEffect(() => {
      // メモ情報
      setMemo(props.memo);

      console.log(props.memo)

      // メモデータ項目数分
      for (let name in props.memo) {
        // ユーザ名とファイルリスト以外をフォーム値へ設定
        if (name != "user_full_name" && name != "files") {
          setValue(name, props.memo[name]);
        }
      }
    }, [props.memos])
  
    // キャンセルボタン
    const onCancelClick = (e) => {
      // 親のダイアログ閉じるイベント
      props.onClose();
    };

    // 保存ボタン
    const saveData = (data) => {
      // 親の保存イベント
      props.onSave(data);
    }

    // 編集ボタン
    const onEditClick = (e) => {
      // 親の編集イベント
      props.onEdit(memo.id);
    };

    // 削除ボタン
    const onDeleteClick = (e) => {
      // 確認ダイアログ表示
      setOpen(true)
    };

    // 確認ダイアログキャンセルボタン
    const handleClose = (e) => {
      // 確認ダイアログ非表示
      setOpen(false)
    }

    // 確認ダイアログ削除ボタン
    const handleDelete = (e) => {
      // 確認ダイアログ非表示
      setOpen(false)
      // 親の削除イベント
      props.onDelete(memo.id);
    };

    // ボタンレンダリング    
    return (
      <>
        <Dialog open={true} onClose={onCancelClick} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <Box component="form" onSubmit={handleSubmit(saveData)} sx={{ mt: 3 }}>
            <DialogTitle id="alert-dialog-title">
              {/* DialogTitle は h2 をレンダーするため内部で h5 をそのまま使うと <h2><h5> の入れ子になり警告になる。component="div" で回避 */}
              <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>メモの編集</Typography>
            </DialogTitle>
            <DialogContent>
              <Stack direction="column" spacing={2}>
                <ThemeInputText id="place" label="場所" placeholder="場所を入力" control={control}/>
                <ThemeInputText id="contents" label="本文" placeholder="本文を入力" multiline rows={4} control={control}/>
              </Stack>
            </DialogContent>
            <DialogActions sx={{p:2}}>
              <Button onClick={onCancelClick} variant="contained" style={{color: 'white', backgroundColor: 'gray'}} autoFocus>キャンセル</Button>
              <Button type="submit" variant="contained" color="secondary" style={{color: 'white'}}>保存</Button>
              <Box style={{flex: '1 0 0'}} />
              <Button onClick={onEditClick} variant="contained" color="warning">編集</Button>
              <Button onClick={onDeleteClick} variant="contained" color="error">削除</Button>
            </DialogActions>
          </Box>
        </Dialog>
        <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>メモの削除</Typography>
          </DialogTitle>
          <DialogContent sx={{pr:20}}>
            <DialogContentText id="alert-dialog-description">
              {/* DialogContentText は <p> を生成するため内部 Typography も <p> だと入れ子警告になる。span に変更 */}
              <Typography variant="inherit" component="span">このメモを削除しますか？</Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{p:2}}>
            <Button onClick={handleClose} variant="contained" style={{color: 'white', backgroundColor: 'gray'}} autoFocus>キャンセル</Button>
            <Button onClick={handleDelete} variant="contained" color="error">削除</Button>
          </DialogActions>
        </Dialog>
      </>
    );
};

// メモ追加ダイアログ
const NewMemoDialog = (props) => {
  const [memo, setMemo] = useState({});
  const { control, handleSubmit, setValue, getValues } = useForm();

  useEffect(() => {
    // メモ情報
    setMemo(props.memo);
    // メモデータ項目数分
    for (let name in props.memo) {
      setValue(name, props.memo[name]);
    }
  }, [props.memos])

  // キャンセルボタン
  const onCancelClick = (e) => {
    // 親のダイアログ閉じるイベント
    props.onClose();
  };

  // 保存ボタン
  const saveData = (data) => {
    // 親の保存イベント
    props.onSave(data);
  }

  // ボタンレンダリング    
  return (
    <>
      <Dialog open={true} onClose={onCancelClick} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <Box component="form" onSubmit={handleSubmit(saveData)} sx={{ mt: 3 }}>
          <DialogTitle id="alert-dialog-title">
            <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>メモの追加</Typography>
          </DialogTitle>
          <DialogContent>
            <Stack direction="column" spacing={2}>
              <ThemeInputText id="place" label="場所" placeholder="場所を入力" control={control}/>
              <ThemeInputText id="contents" label="本文" placeholder="本文を入力" multiline rows={4} control={control}/>
            </Stack>
          </DialogContent>
          <DialogActions sx={{p:2}}>
            <Button onClick={onCancelClick} variant="contained" style={{color: 'white', backgroundColor: 'gray'}} autoFocus>キャンセル</Button>
            <Button type="submit" variant="contained" color="secondary" style={{color: 'white'}}>保存</Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

// メモ地図表示ページ
const MemoViewPage = (props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [ tabValue, setTabValue ] = useState(props.selectTab);
  const [ rows, setRows ] = useState([]);
  const [ memos, setMemos ] = useState([]);
  const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef });
  const [ showNewDlg, setShowNewDlg ] = useState(false);
  const [ showEditDlg, setShowEditDlg ] = useState(false);
  const [ newMemo, setNewMemo ] = useState({});
  const [ editMemo, setEditMemo ] = useState({});

  useEffect(() => {
    // 再読み込みする場合
    let reload = sessionStorage.getItem('reload');
    if (reload == 'on') {
      // メモリスト取得
      fetchRows();
      // 再読み込みクリア
      sessionStorage.removeItem('reload');
    }
    else {
      // メモリストが設定されている場合
      if (location.state?.rows) {
        // メモデータリスト設定
        setRows(location.state.rows)
      }
      else {
        // メモデータリストクリア
        setRows([])
      }
    }
  }, [])

  useEffect(() => {
    // メモ情報リスト更新
    updateMemos()
  }, [rows])
  
  // メモリスト取得
  const fetchRows = async () => {
    try {
      // 検索パラメータ
      const params = {};
      if (props.user != null) {
        params.user_id = props.user.id;
      }
      const query_params = new URLSearchParams(params);
      // API呼び出し
      const data = await authJson(`${apiURL}/memos?` + query_params);
      // メモリスト設定
      setRows(data);
    } 
    catch (e) {
      // 取得エラー
      console.log(e);
      // メモリスト初期化
      setRows([]);
    }
  };

  // タブ変更
  const handleTabChange = (event, newValue) => {
    // リストの場合
    if (newValue == 0) {
      // 1つ前に戻る
      navigate(-1);
    }
    // タブ切替（地図）
    setTabValue(newValue);
  };

  // メモ情報リスト作成
  const updateMemos = () => {
    // メモ情報リスト初期化
    let newMemos = []

    // メモ情報リスト作成
    rows.forEach((row, i) => {
      // 緯度経度が設定されている場合
      if (row.lon != null && row.lon != 0.0 && row.lat != null && row.lat != 0.0) {
        // メモ情報追加
        newMemos.push(row)
      }
    })

    // メモ情報リスト
    setMemos(newMemos)
  }

  // メモ新規登録・更新
  const registData = async (data, mode) =>{
    // ユーザ情報が存在する場合
    if (props.user != null) {
      // ユーザID
      data.user_id = props.user.id;
      // ユーザ名
      if (mode == "New") {  // 新規
        data.entry_account = props.user.username;
      }else {                     // 編集
        data.change_account = props.user.username;
      }
    }
    // フォームデータ追加
    const body = new FormData()
    body.append("props", JSON.stringify(data))
    // メモ新規登録・更新API呼び出し
    let url = ""
    if (mode == "New") {        // 新規
      url = `${apiURL}/memos/create`
    }else {                     // 編集
      url = `${apiURL}/memos/update`
    }
    authFetch(url, { method: 'POST', body, actionName: 'RegistMemo' })
      .then(() => {
        // メモリスト取得
        fetchRows();
      })
      .catch((e) => {
        // 取得エラー
        console.log(e);
      });
  }

  // メモ削除
  const deleteData = (id) => {
    // リクエストデータ作成
    const data = {id: id}
    // ユーザ情報が存在する場合
    if (props.user != null) {
      data.change_account = props.user.username;
    }
    // フォームデータ追加
    const body = new FormData()
    body.append("props", JSON.stringify(data))
    // 取材データ削除API呼び出し
    authFetch(`${apiURL}/memos/delete`, { method: 'POST', body, actionName: 'RemoveMemo' })
      .then(() => {
        // メモリスト取得
        fetchRows();
      })
      .catch((e) => {
        // 取得エラー
        console.log(e);
      });
  };

  // 地図検索マーカクリック
  const handleMapNewMarkerClick = async (memo) => {
    if (!memo) return;
    
    // 場所が設定されている場合
    if (memo.place) {
      // 検索で追加された場合は場所取得済
      memo.placeId = undefined;   // DBには保存しないのでIDは消す
      memo.address = undefined;   // DBには保存しないので住所は消す
      // 新規メモ作成
      setNewMemo(memo)
      // メモの追加ダイアログ表示
      setShowNewDlg(true)
      return;
    }

    // Google Maps API ロードチェック
    if (!window.google?.maps?.places) {
      console.error("Google Maps API not loaded");
      return;
    } 
    // Google Maps API の Geocoder と PlacesService を初期化
    const geocoder = new window.google.maps.Geocoder();
    const service = new window.google.maps.places.PlacesService(document.createElement("div"));    
    const latLng = new window.google.maps.LatLng(memo.lat, memo.lon);

    // 1. PlaceId がある場合は getDetails
    const getPlaceNameFromPlaceId = () => {
      return new Promise((resolve) => {
        if (!memo.placeId) return resolve(null);
        service.getDetails(
          { placeId: memo.placeId, fields: ['geometry', 'name', 'formatted_address'] },
          (place, status) => {
            if (status === "OK" && place) {
              console.log("getPlaceNameFromPlaceId", place)
              resolve({ lat: place.geometry.location.lat(), lon: place.geometry.location.lng(), place: place.name });
            } else {
              console.warn("getPlaceNameFromPlaceId failed:", status);
              resolve(null);
            }
          }
        );
      });
    };

    // 2. NearbySearch
    const getPlaceNameFromNearby = () => {
      return new Promise((resolve) => {
        service.nearbySearch({ location: latLng, radius: 30 }, (res, status) => {
          if (status === "OK" && res.length > 0) {
            console.log("getPlaceNameFromNearby", res[0])
            resolve({ lat: memo.lat, lon: memo.lon, place: res[0].name });
          } else {
            console.warn("getPlaceNameFromNearby failed:", status);
            resolve(null);
          }
        });
      });
    };

    // 3. 逆ジオコーディング
    const getPlaceNameFromGeocode = () => {
      // 名称取得
      const getName = (result) => {
        // formatted_addressじゃ日本か郵便番号まで入ってくるので除去
        let addr = result.formatted_address.replace(/^日本、?|〒\d{3}-\d{4}\s*/g, '');
        return addr;
      };
      // 逆ジオコーディング実行
      return new Promise((resolve) => {
        geocoder.geocode({ location: latLng }, (res, status) => {
          if (status === "OK" && res.length > 0) {
            console.log("getPlaceNameFromGeocode", res[0])
            resolve({ lat: memo.lat, lon: memo.lon, place: getName(res[0]) });
          } else {
            console.warn("getPlaceNameFromGeocode failed:", status);
            resolve({ lat: memo.lat, lon: memo.lon, place: null });
          }
        });
      });
    };

    // 位置名称の取得を実行
    let place = await getPlaceNameFromPlaceId();
    //if (!place) place = await getPlaceNameFromNearby();  // 名称かなりの確率で取得できるが課金対象APIなので注意
    if (!place) place = await getPlaceNameFromGeocode();
    console.log("取得した位置情報:", place)

    // メモの場所に取得した位置名称を設定
    memo.lat = place.lat || memo.lat;
    memo.lon = place.lon || memo.lon;
    memo.place = place.place || "";
    memo.placeId = undefined;   // DBには保存しないのでIDは消す
    memo.address = undefined;   // DBには保存しないので住所は消す

    // 新規メモ作成
    setNewMemo(memo)
    // メモの追加ダイアログ表示
    setShowNewDlg(true)
  }

  // 地図メモマーカクリック
  const handleMapEditMarkerClick = (memo) => {
    // 編集メモ設定
    setEditMemo(memo)
    // メモの編集ダイアログ表示
    setShowEditDlg(true)
  }

  // メモの追加-キャンセルボタン
  const onNewCancel = () => {
    // メモの追加ダイアログ非表示
    setShowNewDlg(false)
  }
  // メモの追加-保存ボタン
  const onNewSave = (data) => {
    // メモ新規作成
    registData(data, "New")
    // メモの追加ダイアログ非表示
    setShowNewDlg(false)
  }
  // メモの編集-キャンセルボタン
  const onEditCancel = (data) => {
    // メモの編集ダイアログ非表示
    setShowEditDlg(false)
  }
  // メモの編集-保存ボタン
  const onEditSave = (data) => {
    // メモ更新
    registData(data, "Edit")
    // メモの編集ダイアログ非表示
    setShowEditDlg(false)
  }
  // メモの編集-編集ボタン
  const onEditDetails = (id) => {
    // 詳細入力へ
    navigate(`/memo/search/details/${id}`, {state: {referrer: location.pathname}});
    // メモの編集ダイアログ非表示
    setShowEditDlg(false)
  }
  // メモの編集-削除ボタン
  const onEditDelete = (id) => {
    // メモ削除
    deleteData(id)
    // メモの編集ダイアログ非表示
    setShowEditDlg(false)
  };

  // レンダリング
  return (
    <Container ref={contentRef}>
      <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={5} sx={{mx: 5, my: 2, width: '95%'}}>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>メモ一覧</Typography>
        <Box displayPrint="none" sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: theme.palette.secondary.light }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="リスト" {...tabProps(0)} />
            <Tab label="地図" {...tabProps(1)} />
          </Tabs>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Box displayPrint="none">
          <SecondButton variant="contained" onClick={() => reactToPrintFn()}>印刷</SecondButton>
        </Box>
      </Stack>
      <TabPanel value={tabValue} index={1}>
        <Box display="flex" direction="column" alignItems="center" justifyContent="center" sx={{ width: '100%', height: '100%' }}>
          <Typography variant="caption" sx={{ px: 3, width: "100%", color:'red', fontSize:'0.82rem', fontWeight:400, lineHeight:1, textAlign:'left' }}>
            ※地図検索で無料枠を超えた場合、課金が発生します
          </Typography>
          <Box sx={{position: 'absolute', px: 3, top: '165px', width: '100%', height: '80vh'}}>
            <MemoEditMap
              memos={memos}
              defaultCenter={defaultCenter}
              onNewMarkerClick={handleMapNewMarkerClick}
              onEditMarkerClick={handleMapEditMarkerClick}
              countryRestriction="JP"
            />
          </Box>          
        </Box>
        {showNewDlg && (
          <NewMemoDialog memo={newMemo} onClose={onNewCancel} onSave={onNewSave}/>
        )}
        {showEditDlg && (
          <EditMemoDialog memo={editMemo} onClose={onEditCancel} onSave={onEditSave} onEdit={onEditDetails} onDelete={onEditDelete}/>
        )}
      </TabPanel>
    </Container>
  );
};

export default MemoViewPage;